import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@sainsburys-tech/bolt';
import { filterAvailability } from '../../helpers/storeHelpers';
import AvailabilityResult from '../AvailabilityResult/AvailabilityResult';
import AvailabilityResultsWrapper from './AvailabilityResults.styles';

var AvailabilityResults = function AvailabilityResults(_ref) {
  var availability = _ref.availability,
      stores = _ref.stores,
      ctaAddToTrolley = _ref.ctaAddToTrolley,
      selectStoreCallback = _ref.selectStoreCallback,
      toggleActiveStore = _ref.toggleActiveStore,
      showExpand = _ref.showExpand,
      showUnavailableMessage = _ref.showUnavailableMessage,
      searchTerm = _ref.searchTerm,
      activeFilter = _ref.activeFilter,
      wrapperStyles = _ref.wrapperStyles,
      selectStoreButtonKind = _ref.selectStoreButtonKind;
  var filteredAvailabilityResults = filterAvailability(availability, activeFilter);
  return /*#__PURE__*/React.createElement(AvailabilityResultsWrapper, {
    styles: wrapperStyles
  }, /*#__PURE__*/React.createElement("div", {
    "data-test": "component-store-selector-stores-list-container"
  }, /*#__PURE__*/React.createElement("ol", {
    "data-test": "component-store-selector-stores-list"
  }, showUnavailableMessage && filteredAvailabilityResults.length === 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Alert, {
    kind: "error",
    isCloseable: false,
    "data-test": "component-store-selector-noresult"
  }, "Sorry, no stores match your exact search.", /*#__PURE__*/React.createElement("br", null), "Try changing the postcode or the collection time above.")), filteredAvailabilityResults.length > 0 && filteredAvailabilityResults.map(function (storeAvailability) {
    var store = stores[storeAvailability.storeId];
    if (!store) return null;
    return /*#__PURE__*/React.createElement(AvailabilityResult, {
      key: store.id,
      store: store,
      storeDistance: storeAvailability.storeDistance,
      showExpand: showExpand,
      availability: storeAvailability.availability,
      products: storeAvailability.products,
      selectStoreCallback: selectStoreCallback,
      ctaAddToTrolley: ctaAddToTrolley,
      searchTerm: searchTerm,
      toggleActiveStore: toggleActiveStore,
      selectStoreButtonKind: selectStoreButtonKind
    });
  }))));
};

AvailabilityResults.propTypes = {
  availability: PropTypes.array,
  stores: PropTypes.object,
  ctaAddToTrolley: PropTypes.func,
  selectStoreCallback: PropTypes.func,
  toggleActiveStore: PropTypes.func,
  showExpand: PropTypes.bool,
  activeFilter: PropTypes.object,
  showUnavailableMessage: PropTypes.bool,
  searchTerm: PropTypes.string,
  wrapperStyles: PropTypes.object,
  selectStoreButtonKind: PropTypes.string
};
AvailabilityResults.defaultProps = {
  ctaAddToTrolley: function ctaAddToTrolley() {}
};
export default AvailabilityResults;